'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import { marketSegmentData } from './intelligenceData';
import { TrendingUp, BarChart2 } from 'lucide-react';

const MarketRadialChart = dynamic(() => import('./MarketRadialChart'), { ssr: false });
const MarketTrendChart = dynamic(() => import('./MarketTrendChart'), { ssr: false });

export default function IntelligenceMarketChart() {
  return (
    <div className="space-y-6">
      {/* Radial — segment distribution */}
      <div className="bg-card border border-muted rounded-sm p-5">
        <div className="flex items-center gap-2 mb-1">
          <BarChart2 size={14} className="text-gold" />
          <h3 className="text-sm font-semibold text-cream tracking-wide">
            Report Coverage
          </h3>
        </div>
        <p className="text-xs text-muted-foreground mb-5">
          Intelligence reports by market segment
        </p>
        <MarketRadialChart data={marketSegmentData} />
        {/* Legend */}
        <div className="mt-4 space-y-2">
          {marketSegmentData?.map((seg) => (
            <div key={`legend-${seg?.name?.replace(/\s+/g, '-')?.toLowerCase()}`} className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span
                  className="w-2 h-2 rounded-full flex-shrink-0"
                  style={{ backgroundColor: seg?.fill }}
                />
                <span className="text-xs text-muted-foreground">{seg?.name}</span>
              </div>
              <span className="text-xs text-cream font-medium text-tabular">{seg?.value}</span>
            </div>
          ))}
        </div>
      </div>
      {/* Market trend — value index */}
      <div className="bg-card border border-muted rounded-sm p-5">
        <div className="flex items-center gap-2 mb-1">
          <TrendingUp size={14} className="text-gold" />
          <h3 className="text-sm font-semibold text-cream tracking-wide">
            Luxury Asset Index
          </h3>
        </div>
        <p className="text-xs text-muted-foreground mb-4">
          Composite value movement — 12 months
        </p>
        <MarketTrendChart />
      </div>
      {/* Member intelligence stats */}
      <div className="bg-card border border-muted rounded-sm p-5">
        <h3 className="text-xs tracking-widest uppercase text-muted-foreground mb-4">
          Your Intelligence Activity
        </h3>
        <div className="space-y-4">
          {[
            { id: 'stat-001', label: 'Reports Read', value: '14', sub: 'This month' },
            { id: 'stat-002', label: 'Reports Saved', value: '6', sub: 'In your desk' },
            { id: 'stat-003', label: 'Market Segments', value: '4', sub: 'Being tracked' },
            { id: 'stat-004', label: 'New Since Last Visit', value: '3', sub: 'Released 13–15 Aug' },
          ]?.map((stat) => (
            <div key={stat?.id} className="flex items-center justify-between">
              <div>
                <p className="text-sm text-cream">{stat?.label}</p>
                <p className="text-xs text-muted-foreground mt-0.5">{stat?.sub}</p>
              </div>
              <span className="font-editorial text-xl font-bold text-gold text-tabular">{stat?.value}</span>
            </div>
          ))}
        </div>
      </div>
      {/* Analyst note */}
      <div className="border border-gold/20 bg-gold/5 rounded-sm p-5">
        <p className="text-xs tracking-widest uppercase text-gold mb-3">Analyst Note</p>
        <p className="text-sm text-cream/80 leading-relaxed italic font-editorial">
          "The convergence of supply scarcity and new collector demand in the Kashmir sapphire and pre-1970 complication markets represents the most compelling collector opportunity we have identified since 2019."
        </p>
        <p className="text-xs text-muted-foreground mt-3">— I. Moreau-Delacroix, Senior Analyst</p>
      </div>
    </div>
  );
}